import React, {createContext, ReactNode, useState} from 'react';

import {getDefaultRecordsFilter} from '/util/filter.util';

// @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
export const RecordsFilterContext = createContext();
interface RecordsFilterContextProviderProps {
  children: ReactNode;
}
export function RecordsFilterContextProvider({
  children,
}: RecordsFilterContextProviderProps) {
  const [filterParams, setSelectedFilterParams] = useState({});

  const setInitialFilterParams = ({recordsName}: any) => {
    const updatedFilterParams = {
      ...filterParams,
      [recordsName]: getDefaultRecordsFilter({recordsName}),
    };
    setSelectedFilterParams(updatedFilterParams);
  };

  // @ts-expect-error TS(7031): Binding element 'updatedFilterParams' implicitly h... Remove this comment to see the full error message
  const setSelectedFilterParam = ({param, recordsName}) => {
    const updatedFilterParams = {
      ...filterParams,
      [recordsName]: param,
    };
    setSelectedFilterParams(updatedFilterParams);
  };

  return (
    <RecordsFilterContext.Provider
      value={{
        filterParams,
        setSelectedFilterParam,
        setInitialFilterParams,
      }}>
      {children}
    </RecordsFilterContext.Provider>
  );
}
